/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, {
  useState, useEffect, useMemo,
} from 'react';
import moment from 'moment';
import { Controller, useForm } from 'react-hook-form';
import {
  RideSelect, RideTextField, RideSelectTextField, RideCheckbox, RideButton,
} from '@rimac-seguros/ride-system-components';

import { useAppContext } from '../../../AppProvider';
import {
  createDigitalId,
  getPersonData,
  registerLead,
  validatePolicy,
} from '../../../services/clientServices';
import {
  calculateAge, getCampaign, getErrorPage, getCodeError, getCodeBduService, trackerBdu, trackingOrigenBDU,
} from '../../../utils/helpers';
import { decryptAES, encryptAES, getCodeSecurity } from '../../../utils/functions';
import ModalPortal from '../../../components/molecules/rbrModal/ModalPortal';
import {
  getTagActionName, getTagApplication, getTagError, getTagLog, getTagMetadata,
} from '../../../utils/analytics';
import { NOT_FOUND_ERRORS } from '../../../utils/constants';
import Regex from '../../../utils/regex';
import { LIST_DOCUMENT, getDocumentTypeByValue } from '../../../constants/list-document';
import InputBirthdateRide from '../../../components/atoms/input-birthdate-ride';
import ModalCurrentPolicy from '../modal-current-policy';
import { ADDITIONAL_USE_CONSENT_URL } from '../../../utils/constants/policies';
import { logsConfig } from '../../../auditory/provider/actions';
import { useAuditory } from '../../../auditory/provider/hooks';
import { Monitoring } from '../../../auditory/utils/monitoring';
import { getDevice } from '../../../auditory/utils/functions';
import { REACT_APP_COOKIE_INSTANA } from '../../../utils/constants/api-constants';
import { useHistory } from '../../../hooks/useHistory';

import './styles.scss';

const ERROR_RENIEC = 'GCPRF004';
const ERROR_DOC = 'GCGNR002';

const FormHero = () => {
  const [, setViewScroll] = useState(true);
  const [loading, setLoading] = useState(false);
  const [origen, setOrigen] = useState('');
  const [showInputBirthday, setShowInputBirthday] = useState(false);
  const [disabledInputs, setDisabledInputs] = useState(false);
  const [commercialModal, setCommercialModal] = useState(false);
  const {
    dispatch,
    state: { client },
  } = useAppContext();
  const { dispatch: dispatchAuditory } = useAuditory();
  const [showModalPolizaActiva, setShowModalPolizaActiva] = useState(false);
  const [nextPage, setNextPage] = useState(false);
  const { navigate } = useHistory();
  const [clientNotFound, setClientNotFound] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidation, setIsValidation] = useState(false);
  const [prevDocumentNumber, setPrevDocumentNumber] = useState('');
  const [interactionField, setInteractionField] = useState('');
  const [isFirstInteraction, setIsFirstInteraction] = useState(false);

  const {
    control,
    register,
    watch,
    setValue,
    reset,
    formState: { errors, isValid },
    setError,
    trigger,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues: {
      terms: false,
      documentType: 'dni',
    },
  });

  const handleScroll = () => setViewScroll(window.scrollY <= 300);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const encodedDocumentType = query.get('tipoDocumento');
    const encodedDocumentNumber = query.get('nroDocumento');
    const encodedCelular = query.get('celular');
    const encodedChannel = query.get('canal');
    if (encodedDocumentType && encodedDocumentNumber && encodedChannel && encodedCelular) {
      const decodedDocumentTypeNumber = window.atob(encodedDocumentType);
      const decodedDocumentType = decodedDocumentTypeNumber === '4' ? 'ce' : 'dni';
      const decodedDocumentNumber = window.atob(encodedDocumentNumber);
      const decodedCelular = window.atob(encodedCelular);
      const decodedChannel = window.atob(encodedChannel);
      sessionStorage.setItem('canal', decodedChannel);
      setValue('documentNumber', decodedDocumentNumber, { shouldValidate: true });
      setValue('documentType', decodedDocumentType, { shouldValidate: true });
      setValue('phone', decodedCelular, { shouldValidate: true });
      setOrigen(decodedChannel === 'app');
      // eslint-disable-next-line no-use-before-define
      getClient(decodedCelular, decodedDocumentNumber, decodedDocumentTypeNumber, decodedDocumentType, decodedChannel);
    }
    dispatch({ type: 'CLEAN_EXPERIMENT_CYBER' });
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleInputPhone = (event) => {
    const el = event.target;
    el.value = el.value.replace(/[^0-9]/g, '');
  };

  const handleInputDocument = (event) => {
    const el = event.target;
    el.value = watch('documentType') === 'dni' ? el.value.replace(/[^0-9]/g, '') : el.value.replace(/[^A-Za-z0-9-.]/g, '');
  };

  const getRequestLead = (date, idLead) => {
    let leadObj = {};
    const fechaNacimiento = client.fechaNacimiento || date;
    const formatFechaNacimiento = moment(fechaNacimiento).format('DD/MM/YYYY');
    const clientAge = calculateAge(fechaNacimiento);
    const fullName = client.nombres ? String(client.nombres).concat(' ', client.apellidoPaterno, ' ', client.apellidoMaterno) : null;

    if (!errors?.documentNumber) {
      const getResultOrigin = getCampaign();
      leadObj = {
        nombres: fullName ? encryptAES(fullName, getCodeSecurity()) : null,
        tipoDocumento: watch('documentType').toUpperCase(),
        nroDocumento: watch('documentNumber'),
        celular: watch('phone') || '',
        fechaNacimiento: fechaNacimiento ? encryptAES(formatFechaNacimiento, getCodeSecurity()) : null,
        correo: '',
        codigoSubProducto: 'comprar-seguro-salud-flexible',
        comunicacionComercial: watch('terms') ? 1 : 0,
        proteccionDatos: 1,
        origen: getResultOrigin?.source,
        finalizado: 1,
        idLead: idLead || null,
        atributos: {
          origenMedio: getResultOrigin?.origenMedio || '',
          origenCampania: getResultOrigin?.origenCampania || '',
          origenContenido: getResultOrigin?.origenContenido || '',
          edad: clientAge || null,
        },
        tipoLead: 'comprar',
        usuarioCreacion: 'VWEBPC',
        estado: 'ACT',
      };
      if (origen) {
        leadObj.origen = 'app';
      }
    }
    return leadObj;
  };

  const documentType = useMemo(() => getDocumentTypeByValue(watch('documentType')), [watch('documentType')]);

  // const handleSilentNextStep = async ({
  //   documento, tipoDocumento, celular, indPoliticaEnvioComunic, indPoliticaProtecDatPers,
  // }) => {
  //   const request = {
  //     tipoDocumento,
  //     numeroDocumento: documento,
  //     canal: 'saludflex',
  //   };
  //   const requestValidate = {
  //     afiliados: [
  //       {
  //         numDocumento: documento,
  //         tipDocumento: tipoDocumento,
  //       },
  //     ],
  //   };
  //   await createDigitalId(request);
  //   const plans = await getPlanData(requestValidation(requestValidate));
  //   dispatch({ type: 'SAVE_INFO', payload: [, plans] });

  //   getPersonData(request)
  //     .then((res) => {
  //       const data = JSON.parse(decryptAES(res.payload.data, getCodeSecurity()));
  //       console.log('--data--');
  //       console.log(data);
  //       trackingOrigenBDU(data.origen, data.tipoDocumento, data.numeroDocumento);
  //       const reference = ['EQU', 'REN'];
  //       data.indExisteTercero = !reference.includes(data.origen);
  //       dispatch({
  //         type: 'SAVE_CLIENT',
  //         payload: {
  //           ...data,
  //           telefono: celular,
  //           indPoliticaEnvioComunic,
  //           indPoliticaProtecDatPers,
  //         },
  //       });

  //       if (!data.indExisteTercero) {
  //         setShowInputBirthday(true);
  //       }
  //       validatePolicy(requestValidate).then((resp) => {
  //         if (resp.payload[0].indPolizaActiva === 1) {
  //           data.indPolizaActiva = true;
  //           dispatch({
  //             type: 'SAVE_CLIENT',
  //             payload: {
  //               ...data,
  //               telefono: celular,
  //               indPoliticaEnvioComunic,
  //               indPoliticaProtecDatPers,
  //             },
  //           });
  //           // setShowModalPolizaActiva(true);
  //         }
  //       });
  //       return {
  //         ...data,
  //         telefono: celular,
  //         indPoliticaEnvioComunic,
  //         indPoliticaProtecDatPers,
  //       };
  //     })
  //     .then((client) => {
  //       const leadWithoutId = {
  //         nombres: `${client.nombres} ${client.apellidoPaterno} ${client.apellidoMaterno}`,
  //         tipoDocumento: getDocumentType(Number(client.tipoDocumento))?.name,
  //         nroDocumento: client.numeroDocumento,
  //         celular: client.telefono,
  //         fechaNacimiento: client.fechaNacimiento,
  //         correo: client.correo,
  //         codigoSubProducto: 'comprar-seguro-salud-flexible',
  //         comunicacionComercial: client.indPoliticaEnvioComunic === 'NO' ? 0 : 1,
  //         proteccionDatos: client.indPoliticaProtecDatPers === 'NO' ? 0 : 1,
  //         origen: client.origen,
  //         finalizado: 1,
  //         idLead: null,
  //         tipoLead: 'COMPRAR',
  //         usuarioCreacion: 'VWEBPC',
  //         estado: 'ACT',
  //       };

  //       return registerLead(leadWithoutId)
  //         .then((response) => {
  //           setNewLead(response.payload);
  //           const leadWithId = { ...leadWithoutId, idLead: response?.payload.idlead };
  //           dispatch({ type: 'ADD_LEAD_DATA', payload: leadWithId });
  //         })
  //         .then(() => client);
  //     })
  //     .then((client) => {
  //       setClientNotFound(false);
  //       const clientAge = calculateAge(client.fechaNacimiento);
  //       createQuote(requestQuote([{ parentesco: 0, edad: clientAge }]))
  //         .then((payload) => {
  //           const plansFlex = payload.rptaCalculoPrima;
  //           const idPlanBase = Number(decryptCredentials(process.env.REACT_APP_PLAN_BASE));
  //           const idPlanPlus = Number(decryptCredentials(process.env.REACT_APP_PLAN_PLUS));
  //           const planBase = plansFlex.filter((e) => e.nroPlan === idPlanBase);
  //           const planPlus = plansFlex.filter((e) => e.nroPlan === idPlanPlus);
  //           dispatch({ type: 'SAVE_ID_QUOTE', payload: payload.ideCotizacion });
  //           dispatch({ type: 'SAVE_PLANS_FLEX', payload: plansFlex });
  //           const reqPlanSelected = {
  //             idQuote: payload.ideCotizacion,
  //             planFlexSelected: planBase[0],
  //             secondPlanFlexSelected: planPlus[0],
  //           };
  //           selectPlan(requestSelectPlan(reqPlanSelected))
  //             .then(() => {
  //               const reqThird = {
  //                 idQuote: payload.ideCotizacion,
  //                 client,
  //                 address: state?.address || {},
  //               };
  //               addThirdInQuote(requestThird(reqThird))
  //                 .then(() => {
  //                   calculateDiscount(requestCalculatePlan(payload.ideCotizacion))
  //                     .then((res) => {
  //                       const plansFlexDiscount = res[0]?.rptaCalculoPrima;
  //                       const planBaseDiscount = plansFlexDiscount.filter((e) => e.nroPlan === idPlanBase);
  //                       const planPlusDiscount = plansFlexDiscount.filter((e) => e.nroPlan === idPlanPlus);
  //                       const quote = {
  //                         planBase,
  //                         planPlus,
  //                         planBaseDiscount,
  //                         planPlusDiscount,
  //                       };
  //                       dispatch({ type: 'SAVE_PLANS_FLEX_DISCOUNT', payload: plansFlexDiscount });
  //                       dispatch({ type: 'SAVE_QUOTE', payload: quote });
  //                       setShowModalSilentOneStep(false);
  //                     })
  //                     .catch((error) => navigate(getErrorPage(error, 'CALCULAR_DESCUENTO')));
  //                 })
  //                 .catch((error) => navigate(getErrorPage(error, 'AGREGAR_TERCERO')));
  //             })
  //             .catch((error) => navigate(getErrorPage(error, 'SELECCIONAR_PLAN')));
  //         })
  //         .catch((error) => navigate(getErrorPage(error, 'CREAR_COTIZACION')));
  //     })
  //     .catch((error) => {
  //       setClientNotFound(false);
  //       setShowModalSilentOneStep(false);
  //       trackingOrigenBDU(undefined, request.tipoDocumento, request.numeroDocumento);
  //       const msg = error.response.data.error.message;
  //       const codeErrorBdu = getCodeBduService(msg);

  //       if (codeErrorBdu.includes(ERROR_DOC) && documentType.id === 4) setShowInputBirthday(true);

  //       if (codeErrorBdu.includes(ERROR_RENIEC) || codeErrorBdu.includes(ERROR_DOC)) {
  //         setShowInputBirthday(false);
  //         setClientNotFound(true);
  //       }

  //       if (codeErrorBdu.includes(ERROR_DOC)) {
  //         trackerBdu('NE', watch('documentType'), watch('documentNumber'), 'Origen validación Cliente');
  //       }

  //       const errorCustomized = getCodeError(error);
  //       if (!NOT_FOUND_ERRORS.includes(errorCustomized)) {
  //         setShowInputBirthday(true);
  //         validatePolicy(requestValidate);
  //         return;
  //       }
  //       dispatch({ type: 'SAVE_CLIENT', payload: { type: 'token' } });
  //       navigate(getErrorPage(error, 'OBTENER_PERSONA'));
  //     });
  // };

  const resetStates = () => {
    setIsValidation(false);
    setIsSubmit(false);
    setDisabledInputs(false);
    setLoading(false);
  };

  const getClient = (phone, decodedDocumentNumber, decodedDocumentTypeNumber, decodedDocumentType, decodedChannel) => {
    setShowInputBirthday(false);
    setIsValidation(true);
    const validDocument = !errors?.documentNumber || decodedDocumentNumber;
    if (validDocument) {
      const request = {
        tipoDocumento: decodedDocumentTypeNumber || String(documentType.id),
        numeroDocumento: decodedDocumentNumber || watch('documentNumber'),
        canal: 'saludflex',
      };
      const requestValidate = {
        afiliados: [
          {
            numDocumento: decodedDocumentNumber || watch('documentNumber'),
            tipDocumento: decodedDocumentTypeNumber || String(documentType.id),
          },
        ],
      };
      getPersonData(request)
        .then((res) => {
          setClientNotFound(false);
          const data = JSON.parse(decryptAES(res.payload.data, getCodeSecurity()));
          trackingOrigenBDU(data.origen, data.tipoDocumento, data.numeroDocumento);
          const reference = ['EQU', 'REN'];
          data.indExisteTercero = !reference.includes(data.origen);
          dispatch({ type: 'SAVE_CLIENT', payload: data });
          if (!data.indExisteTercero) {
            setShowInputBirthday(true);
            resetStates();
          }

          validatePolicy(requestValidate).then((resp) => {
            setIsValidation(false);
            if (resp.payload[0].indPolizaActiva === 1) {
              data.indPolizaActiva = true;
              dispatch({ type: 'SAVE_CLIENT', payload: data });
              setShowModalPolizaActiva(true);
              getTagLog('Parece que ya eres parte de nuestra familia – Póliza de salud vigente', 'trackLog');
            }
          }).catch(() => {
            resetStates();
            setTimeout(() => {
              const element = document.getElementsByName('documentNumber');
              element[0].focus();
            }, 100);
          });
        })
        .catch((error) => {
          setClientNotFound(false);
          if (!decodedChannel) {
            resetStates();
          }
          trackingOrigenBDU(undefined, request.tipoDocumento, request.numeroDocumento);
          const msg = error.response.data.error.message;
          const codeErrorBdu = getCodeBduService(msg);

          if (codeErrorBdu.includes(ERROR_DOC) && (documentType.id === 4 || decodedDocumentTypeNumber === '4')) setShowInputBirthday(true);

          if (codeErrorBdu.includes(ERROR_RENIEC) || codeErrorBdu.includes(ERROR_DOC)) {
            setShowInputBirthday(false);
            setClientNotFound(true);
          }

          if (codeErrorBdu.includes(ERROR_DOC)) {
            trackerBdu('NE', watch('documentType') || decodedDocumentType, watch('documentNumber') || decodedDocumentNumber, 'Origen validación Cliente');
          }

          const errorCustomized = getCodeError(error);
          if (!NOT_FOUND_ERRORS.includes(errorCustomized)) {
            setShowInputBirthday(true);
            validatePolicy(requestValidate);
            return;
          }
          dispatch({ type: 'SAVE_CLIENT', payload: { type: 'token' } });
          navigate(getErrorPage(error, 'OBTENER_PERSONA'));
        });
    }
  };

  const updateConfigLog = ({
    idLead,
  }) => {
    const documentType = watch('documentType');
    const documentNumber = watch('documentNumber');
    const getResultOrigin = getCampaign();
    const configAuditory = {
      placa: '',
      tipoDocumento:
        String(documentType).length === 1
          ? `0${documentType}`
          : `${documentType === 'DNI' ? '02' : '04'}`,
      numeroDocumento: String(documentNumber),
      correo: client?.email || '',
      telefono: watch('phone'),
      producto: 'SAL-FLEX',
      codigoProducto: 'AMI',
      codigoExterno: client ? client.tercero : '',
      idLead,
      canal: 'Portal Web',
      origen: `${getResultOrigin.source}||${client.origen || ''}`,
      proteccionDatos: 1,
      comunicacionComercial: watch('terms') ? 1 : 0,
      pasoInicialFinalizado: 1,
      device: getDevice(),
    };

    logsConfig(dispatchAuditory, configAuditory);
  };

  useEffect(() => {
    if (nextPage) {
      getTagMetadata('Datos Personales', showInputBirthday ? 'Cliente nuevo' : 'Cliente ya existe', 'trackMetadata');
      navigate('/comprar/seguro-salud-flexible/planes');
    }
  }, [nextPage]);

  useEffect(() => {
    Monitoring.startMonitoring({
      version: '1.0.0',
      product: 'SAL-FLEX',
    });
  }, []);

  const handleValidate = async () => {
    await trigger();

    if (!isValid || Object.keys(errors).length > 0) return;

    setDisabledInputs(true);
    setLoading(true);

    if (isValidation) {
      setIsSubmit(true);
      return;
    }

    client.telefono = watch('phone');
    dispatch({ type: 'SAVE_CLIENT', payload: client });

    if (clientNotFound && (parseInt(client.tipoDocumento, 10) === 2 || documentType.id === 2)) {
      dispatch({ type: 'NON_EXISTENT_DOCUMENT', payload: true });
      getTagError('ErrorSolicitarSaludFlexible', 'Número de documento inexistente', 'VALIDAR_DOCUMENTO');
      handleCallLead(null);
      navigate('/comprar/seguro-salud-flexible/planes/gracias');
      return;
    }

    const request = {
      tipoDocumento: documentType.name,
      numeroDocumento: watch('documentNumber'),
      tipoFlujo: 'SAL-FLE',
    };

    const birthdate = watch('birthdate') ?? client.fechaNacimiento;
    const clientDate = birthdate ? moment(birthdate, true).format('YYYY-MM-DD') : '';
    const clientAge = calculateAge(clientDate);

    if (parseInt(client.indvalidadoper, 10) === 0 && client.origen === 'BDU' && parseInt(client.tipoDocumento, 10) === 2) {
      handleCallLead(clientDate);
      navigate('/comprar/seguro-salud-flexible/planes/gracias');
      return;
    }

    if (clientAge < 18 || clientAge > 60) {
      handleCallLead(clientDate);
      return navigate('/comprar/seguro-salud-flexible/planes/gracias-edad');
    }

    if (client?.indPolizaActiva) {
      handleCallLead(clientDate);
      return navigate('/comprar/seguro-salud-flexible/planes/gracias-cliente');
    }

    Promise.all([
      createDigitalId(request),
      registerLead(getRequestLead(clientDate))
    ])
      .then((payload) => {

        Monitoring.startSession({
          userId: payload[0],
          docNumber: watch('documentNumber'),
          docType: documentType.id,
          phone: watch('phone'),
          plate: '',
          cookieKey: REACT_APP_COOKIE_INSTANA ?? '-',
        });

        const idLead = payload[1].payload?.idLead;

        dispatch({ type: 'SAVE_INFO', payload });
        dispatch({ type: 'ADD_LEAD_DATA', payload: getRequestLead(clientDate, idLead) });
        updateConfigLog({ idLead });

        getTagApplication(
          "Seguro Salud Flexible",
          idLead,
          "trackStartApplication",
          watch("phone"),
          watch("documentNumber"),
        );

        if (showInputBirthday) {
          dispatch({
            type: 'SAVE_CLIENT',
            payload: {
              tercero: false,
              fechaNacimiento: clientDate,
              numeroDocumento: watch('documentNumber'),
              telefono: watch('phone'),
              tipoDocumento: documentType.id,
              nombres: '',
              apellidoMaterno: '',
              apellidoPaterno: '',
              gender: false,
              correo: '',
              sexo: '',
              indExisteTercero: false,
            },
          });
        }
        setNextPage(true);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        navigate('/comprar/seguro-salud-flexible/error');
      });
  };

  const handleCallLead = async (clientDate) => {
    const resp = await registerLead(getRequestLead(clientDate));
    getTagApplication(
      "Seguro Salud Flexible",
      resp?.payload?.idLead,
      "trackStartApplication",
      watch("phone"),
      watch("documentNumber"),
    );
  }

  useEffect(() => {
    if (isSubmit && !isValidation) {
      handleValidate();
    }
  }, [isSubmit, isValidation]);

  useEffect(() => {
    if (!isFirstInteraction && interactionField) {
      handleTrackEvents(`Primera interacción - ${interactionField}`);
      setIsFirstInteraction(true);
    }
  }, [isFirstInteraction, interactionField]);

  const toggleModalPolizaActiva = (isConfirm) => {
    setShowModalPolizaActiva(!showModalPolizaActiva);
    if (isConfirm) {
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Poliza salud vigente', 'De acuerdo', 'trackAction');
    }
  };

  const toggleModalCom = () => {
    setCommercialModal(!commercialModal);
  };

  const handleTrackEvents = (label) => {
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', label, 'trackAction');
  };

  return (
    <>
      {/* {showModalSilentOneStep && <LoaderModal />} */}
      <div className="form-hero">
        <div className="form-hero__fields">
          <div className="form-hero__field">
            <RideSelectTextField
              label="Nro. de documento"
              size="large"
              disabled={disabledInputs || origen}
              error={!!errors?.documentNumber}
              errorMessage={errors?.documentNumber?.type === 'required' ? 'Es necesario que ingreses tu Nro. de documento' : 'Formato de documento incorrecto'}
            >
              <RideSelect
                {...register('documentType', { required: true })}
                watchFieldRHF={watch('documentType')}
                options={LIST_DOCUMENT.filter((_) => _.active)}
                onSelect={(e) => reset({ documentType: e.value, documentNumber: '' })}
                onClick={() => setInteractionField('Documento')}
              />
              <RideTextField
                {...register('documentNumber', {
                  required: true,
                  minLength: watch('documentType') === 'dni' ? 8 : 9,
                  onBlur: () => {
                    const currentDocumentNumber = watch('documentNumber');
                    if (!errors?.documentNumber && !!currentDocumentNumber && currentDocumentNumber !== prevDocumentNumber) {
                      getClient(watch('phone'));
                      setPrevDocumentNumber(currentDocumentNumber);
                    }
                  },
                })}
                autoComplete="off"
                maxLength={watch('documentType') === 'dni' ? 8 : 11}
                onInput={handleInputDocument}
                onClick={() => setInteractionField('Nro. Documento')}
              />
            </RideSelectTextField>
          </div>
          <div className="form-hero__field">
            <RideTextField
              {...register('phone', { required: true, minLength: 9, pattern: Regex.phone })}
              aria-required
              label="Celular"
              maxLength={9}
              size="large"
              disabled={disabledInputs}
              autoComplete="off"
              onInput={handleInputPhone}
              onClick={() => setInteractionField('Celular')}
              error={!!errors?.phone}
              errorMessage={errors?.phone?.type === 'required' ? 'Es necesario que ingreses tu número de celular' : 'Formato de número de celular incorrecto'}
            />
          </div>
          {showInputBirthday && (
            <div className="form-hero__date">
              <Controller
                name="birthdate"
                control={control}
                rules={{ required: showInputBirthday }}
                render={({ field }) => (
                  <InputBirthdateRide
                    label="Fecha de nacimiento"
                    value={field.value}
                    showError={!!errors?.birthdate}
                    errorText="Ingrese una fecha válida"
                    disabled={disabledInputs}
                    onChange={(value) => field.onChange(value)}
                    onError={(e) => {
                      if (e) {
                        setError('birthdate', { type: 'custom' });
                      }
                    }}
                    onClick={() => setInteractionField('Fecha de nacimiento')}
                  />
                )}
              />
            </div>
          )}
        </div>
        <div className="form-hero__info">
          <p>
            Como parte del proceso de cotización nos contactaremos contigo a la brevedad, para poder asesorarte.
          </p>
        </div>
        <div className="form-hero__terms">
          <p className="form-hero__terms-privacy">
            Al continuar acepto la
            <a rel="noopener noreferrer" href="https://www.rimac.com/politica-privacidad" target="_blank" onClick={() => handleTrackEvents('Política de Privacidad')}>
              Política de Privacidad
            </a>
          </p>
          <RideCheckbox
            {...register('terms')}
            watchFieldRHF={watch('terms')}
            className="form-hero__terms-commercial"
            size="small"
            onClick={() => setInteractionField('Check de protección')}
          >
            <p>
              Acepto el{' '}
              <a href={ADDITIONAL_USE_CONSENT_URL} target="_blank" rel="noopener noreferrer">Consentimiento para usos adicionales</a>
            </p>
          </RideCheckbox>
        </div>
        <RideButton
          text="Cotiza ahora"
          size="x-large"
          type="button"
          loading={loading}
          onClick={() => {
            setInteractionField('Botón cotizar');
            if (!loading) {
              handleValidate();
            }
          }}
        />
      </div>
      {commercialModal && (
        <ModalPortal
          isOpen={commercialModal}
          title="POLÍTICA DE ENVÍO DE COMUNICACIONES COMERCIALES"
          description="Autorizo a RIMAC a utilizar mis Datos Personales y que los mismos sean tratados por terceros, para que me sean ofrecidos beneficios, productos y servicios de RIMAC, a través de cualquier medio de comunicación. Declaro conocer que el no conceder esta autorización no afectará la prestación del servicio contratado."
          callbackClose={toggleModalCom}
          extraClass="modal-pol-com"
        />
      )}
      {showModalPolizaActiva && (
        <ModalCurrentPolicy
          isOpen={showModalPolizaActiva}
          title="Parece que ya eres parte de nuestra familia"
          description="Cuentas con una póliza de salud vigente, pero puedes seguir cotizando. ¿Deseas continuar?"
          onConfirm={() => toggleModalPolizaActiva(true)}
          onClose={toggleModalPolizaActiva}
        />
      )}
    </>
  );
};

export default FormHero;
